import React from 'react'

export default function CardIconView({ iconSrc, style = {} }) {
   return (
      <div>
         <div style={{backgroundColor:'#0d6efd',width:'50px',borderRadius:'50%',height:'50px',...style}} class="d-flex align-items-center justify-content-center text-white p-3 " bis_skin_checked="1">{iconSrc ? <img style={{maxWidth:'20px',color:'white',maxHeight:'20px'}} src={iconSrc} /> : <i class="bi bi-activity"></i>}</div>
      </div>
   )
}
